import axios from 'axios';
import { ACCESS_TOKEN_STORAGE_KEY } from '@/features/auth/constants.ts';

export const axiosInstance = axios.create({
  baseURL: window.API_URL,
});

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem(ACCESS_TOKEN_STORAGE_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
